import * as React from "react";

export type ColorMode = "auto" | "dark" | "light";

interface ColorModeContextType {
  colorMode: ColorMode;
  /** `colorMode` with "auto" resolved against the system's preference. */
  resolvedColorMode: "light" | "dark";
  toggleColorMode: () => void;
}

export const ColorModeContext = React.createContext<ColorModeContextType>({
  colorMode: "auto",
  resolvedColorMode: "light",
  toggleColorMode: () => {},
});

export function useColorMode() {
  return React.useContext(ColorModeContext);
}
